
export default {
  name: 'ProductInfoGallerySliderSlideThumbnail',
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    index: {
      type: Number,
    },
    isGalleryPopup: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isBoutiquePage() {
      return this.$store.state.metaData?.addons?.head?.isBoutique || false;
    },
    additionalClasses() {
      if (!this.item.classes?.length) {
        return {};
      }

      const classes = {};
      const iterate = (className) => Object.assign(classes, { [className]: true });

      this.item.classes.forEach(iterate);

      return classes;
    },
  },
};
